import React from 'react';
import { PaginationStyle } from './style';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownRoot,
  DropdownToggle,
  ThemeProvider,
} from '@alphonsocode/kallos';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import useQuery from 'reusable/customHooks/useQuery';
import { PageSizes } from 'containers/NewCreativePreview/constants';
import { track } from 'analytics/posthog';

function PaginationComponent({
  totalCount,
  size,
  setPageSize,
  page,
  setPageNumber,
  showTotal = true,
  showPage = true,
  showSize = true,
  isDataLoading,
  isDataFetching,
}) {
  const [query, setQuery] = useQuery();

  const handlePageSizeChange = e => {
    setPageSize(e);
    setQuery({ limit: e, page: '1' });
    track('adsure pagination changed', {
      adsure_test_tag: query.get('testTag') || 'cta',
      page: 1,
      limit: e,
      total_pages: Math.max(1, Math.ceil(totalCount / e) || 1),
      my_campaigns: query.get('myCampaigns') === 'true',
      my_tests: query.get('myTests') === 'true',
      surface: 'adsure',
    });
  };

  const handlePageNumberChange = e => {
    setPageNumber(Number(e));
    setQuery('page', e);
    track('adsure pagination changed', {
      adsure_test_tag: query.get('testTag') || 'cta',
      page: Number(e),
      limit: size,
      total_pages: totalPages,
      my_campaigns: query.get('myCampaigns') === 'true',
      my_tests: query.get('myTests') === 'true',
      surface: 'adsure',
    });
  };

  const totalPages = Math.max(1, Math.ceil(totalCount / size) || 1);

  const loading = isDataLoading || isDataFetching; // <== shortcut

  return (
    <PaginationStyle>
      {/* @ts-ignore - ThemeProvider children type issue with React 18 */}
      <ThemeProvider defaultMode="light">
        <div className="paginationDiv">
          {showTotal && (
            <div className="total">
              <span className="heading">Total Results:</span>
              <span className="value">{loading ? '-' : totalCount}</span>
            </div>
          )}

          {showPage && (
            <div className="page">
              <div className="arrowIterator">
                <div
                  className={`arrowButton ${page === 1 ? 'disabled' : ''}`}
                  onClick={() => {
                    if (page > 1 && !loading) {
                      track('adsure pagination changed', {
                        adsure_test_tag: query.get('testTag') || 'cta',
                        page: page - 1,
                        limit: size,
                        total_pages: totalPages,
                        my_campaigns: query.get('myCampaigns') === 'true',
                        my_tests: query.get('myTests') === 'true',
                        surface: 'adsure',
                      });
                      setPageNumber(page - 1);
                      setQuery('page', String(page - 1));
                    }
                  }}
                >
                  <MdChevronLeft style={{ fontSize: 23, color: '#006e7d' }} />
                </div>
              </div>
              <span className="heading" style={{ marginLeft: 15 }}>
                Page:
              </span>
              <DropdownRoot modal={false}>
                <DropdownToggle
                  className="dropdownMain"
                  disabled={loading}
                  style={{
                    width: '70px',
                    height: '25px',
                    marginLeft: '5px',
                    borderRadius: 5,
                    textAlign: 'center',
                  }}
                >
                  {page}
                </DropdownToggle>
                <DropdownMenu
                  style={{
                    scrollbarWidth: 'thin',
                    textAlign: 'center',
                  }}
                >
                  {[...Array(totalPages)].map((_, idx) => {
                    const pageNum = idx + 1;
                    return (
                      <DropdownItem
                        key={pageNum}
                        onSelect={() => handlePageNumberChange(pageNum)}
                      >
                        {pageNum}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </DropdownRoot>
              <span className="value">of {loading ? '-' : totalPages}</span>
              <div className="arrowIterator">
                <div
                  className={`arrowButton ${
                    page + 1 > totalPages ? 'disabled' : ''
                  }`}
                  onClick={() => {
                    if (!loading && page + 1 <= totalPages) {
                      track('adsure pagination changed', {
                        adsure_test_tag: query.get('testTag') || 'cta',
                        page: page + 1,
                        limit: size,
                        total_pages: totalPages,
                        my_campaigns: query.get('myCampaigns') === 'true',
                        my_tests: query.get('myTests') === 'true',
                        surface: 'adsure',
                      });
                      setPageNumber(page + 1);
                      setQuery('page', String(page + 1));
                    }
                  }}
                >
                  <MdChevronRight style={{ fontSize: 23, color: '#006e7d' }} />
                </div>
              </div>
            </div>
          )}

          {showSize && (
            <div className="size">
              <span className="heading">Show:</span>
              <DropdownRoot modal={false}>
                <DropdownToggle className="dropdownMain" disabled={loading}>
                  {size}
                </DropdownToggle>
                <DropdownMenu>
                  {PageSizes.map(option => (
                    <DropdownItem
                      key={option}
                      onSelect={() => handlePageSizeChange(option)}
                    >
                      {option}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </DropdownRoot>
            </div>
          )}
        </div>
      </ThemeProvider>
    </PaginationStyle>
  );
}

export default PaginationComponent;
